import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setSubmitMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // Formspree - no backend needed!
      const response = await fetch('https://formspree.io/f/xzdgeowv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          _subject: `New Contact Form Submission from ${formData.firstName} ${formData.lastName}`,
          _source: 'Contact Page'
        }),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for your interest! We will be in touch soon.');
        setFormData({ firstName: '', lastName: '', email: '' });
      } else {
        setSubmitMessage('Sorry, there was an error sending your message. Please try again or email us directly.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage('Sorry, there was an error sending your message. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Connect with us</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <h3>Locations</h3>
              <p>London · Geneva · Dubai · Rabat</p>
            </div>
            <div className="info-item">
              <h3>Email</h3>
              <a href="mailto:hello@esmehc.com">hello@esmehc.com</a>
            </div>
            <div className="contact-image">
              <img src="/img/ek_website-1.webp" alt="Contact" />
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Connect with us'}
              </button>
              {submitMessage && (
                <p style={{ 
                  marginTop: '15px', 
                  color: submitMessage.includes('error') ? '#d32f2f' : '#2e7d32',
                  fontSize: '14px'
                }}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
